<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { WeightsComparerReadModel } from "@Criteria/Weights/Domain/readmodels";
    import { KendoChart, KendoChartDataSerie, KendoChartOptions } from "@Kendo/Components/KendoChart";
    import { ellipsis, getDistinctColor, roundDecimal } from "@common/Common";
    import { CriterionReadModel } from "@Criteria/Hierarchies/Domain/readmodels";


    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propRm: { type: Object, required: false, default: null },
        },
        watch:
        {
            contextId: 'onContextIdChanged'
        },
    })
    export default class WeightsComparerDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get rm(): WeightsComparerReadModel { return this.$props.propRm as WeightsComparerReadModel; }

        Chart: KendoChart | null = null;
        get contextId(): number { return this.rm?.ContextId ?? null; }
        get context() { return this.rm.Criteria.find(a => a.Id === this.contextId); }
        get parents() { return this.rm.Criteria.filter(a => this.rm.Criteria.some(b => b.ParentId === a.CriterionId)); }

        //@Watch('contextId')
        onContextIdChanged(val: number, oldVal: number)
        {
            if (val != null)
            {
                this.$nextTick(() =>
                {
                    this.RenderChart();
                });
            }
        }

        SetContext(context: CriterionReadModel)
        {
            this.rm.ContextId = context.CriterionId;
        }


        RenderChart()
        {
            const options = new KendoChartOptions();
            options.SetBarSeriesType();
            options.EnableSeriesStack100();
            options.SetCategoryAxis(false, false);
            options.SetValueAxis(null, false, false);
            options.SetLegend(true, "bottom", 35);
            options.SetTooltip(true, "<small>#= dataItem.Category #</small><br> #= dataItem.CriterionName #: #= value #%");

            const chart = KendoChart.CreateChart(options);
            this.Chart = chart;

            const subcriteria = this.rm.Criteria.filter(a => a.ParentId === this.contextId);

            const series: KendoChartDataSerie[] = subcriteria.map((c, i) =>
            {
                const dataItems = this.rm.WeightsSources.map(ws =>
                {
                    const weight = ws.Weights.find(a => a.CriterionId === c.CriterionId).LocalWeight;
                    const value = roundDecimal(100 * weight, 0);

                    return {
                        Category: ellipsis(ws.Name, 40),
                        CriterionName: c.Name,
                        Value: value,
                    };
                });

                const serie = new KendoChartDataSerie();
                serie.SetName(c.Name);
                serie.SetField("Value");
                serie.SetCategoryField("Category");
                serie.SetColor(getDistinctColor(i));
                serie.SetData(dataItems);

                return serie;
            });

            if (series.length > 0)
            {
                series[0].SetLabels(true, "#= category #", "1rem Arial", "insideBase");
                series[0].SetLabelsColor("#fff");
            }

            this.Chart.SetDataSeries(series);

            const minHeightBars = this.rm.WeightsSources.length * 60;
            const minVhPxl = 300;
            const height = Math.max(minHeightBars, minVhPxl);
            this.Chart.SetHeight(height);

            this.Chart.Render1('Weights');
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Weights comparison</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h2 v-if="!rm"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>

                        <div v-if="rm">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    {{context?.Name}}
                                </button>
                                <div class="dropdown-menu" style="max-height: 300px; overflow-y:auto;">
                                    <a class="dropdown-item" v-for="c in parents" :key="c.Id" @click="SetContext(c)">
                                        <span>{{c.Name}}</span><br />
                                        <small>{{c.Path}}</small>
                                    </a>
                                </div>
                            </div>
                            <br />

                            <div id="Chart-Weights"></div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>